{
  "user": {
    "addToDigitalWallet": {
      "cardTitle": "Your Digital Membership Card",
      "cardSubtitle": "Includes all active memberships {'&'} auto-updates",
      "downloadPdf": "Download PDF",
      "autoUpdates": "Automatically updates when memberships change"
    },
    "addressPrice": {
      "priceReason": "You're seeing this price because of your address."
    },
    "displayMembershipCard": {
      "eligibleForEarlyRenewal": "Eligible for early renewal",
      "renewNow": "Renew now →",
      "paymentFailed": "Payment Failed",
      "updateYourCardIn": "Update your card in",
      "paymentSettings": "Payment Settings",
      "nextAttempt": "· Next attempt:",
      "active": "Active",
      "noExpiration": "No expiration",
      "members": "Members",
      "person": "person",
      "people": "people",
      "manageWhoUsesThisMembership": "Manage who uses this membership",
      "notAvailableForThisPlan": "Not available for this plan",
      "autoRenew": "Auto-renew",
      "renewsOnAtNoCharge": "Renews on {date} at no charge",
      "renewManuallyBefore": "Renew manually before {date}",
      "addPaymentMethodToEnable": "Add a payment method to enable",
      "renewsOnFor": "Renews on {date} for {price}",
      "includesMembershipFee": "(includes {fee} membership fee)",
      "autoRenewNotAvailable": "Auto-renew is not available for this membership",
      "whoUsesThisMembership": "Who uses this membership?",
      "chooseWhoReceivesBenefits": "Choose who receives the benefits of this membership.",
      "thisMembershipCovers": "This membership covers",
      "onePerson": "1 person",
      "eitherYouOrFamilyMember": "— either you or a family member.",
      "thisMembershipCoversUpTo": "This membership covers up to",
      "totalIncludingYourself": "total, including yourself.",
      "spotUsed": "spot used",
      "spotsUsed": "spots used",
      "removeSomeoneToAddAnother": "Remove someone to add another",
      "accountHolder": "Account Holder",
      "iUseThisMembershipMyself": "I use this membership myself",
      "youWontReceiveBenefits": "You won't receive membership benefits. All spots go to your family members.",
      "familyMembers": "Family Members",
      "addNew": "Add new",
      "noFamilyMembersYet": "No family members yet.",
      "addAFamilyMember": "Add a family member",
      "toShareThisMembership": "to share this membership.",
      "changeRenewalStatus": "Change Renewal Status",
      "enableAutomaticRenewalFor": "Enable automatic renewal for {name}",
      "youPlus": "You + {names}",
      "you": "You",
      "noOneSelected": "No one selected",
      "failedToUpdateMembers": "Failed to update members. Please try again.",
      "renewalStatusUpdated": "Renewal status updated!",
      "failedToUpdateRenewalStatus": "Failed to update renewal status. Please try again."
    },
    "membershipCard": {
      "earlyRenewal": "Early Renewal",
      "detailsTitle": "{name} Details",
      "startingAt": "Starting at"
    },
    "additionalMembers": {
      "whoElseAssociated": "Who else will be associated with this plan?",
      "selectFromExistingFamilyMembers": "Select from existing family members",
      "addMembersToYourAccount": "Add members to your account who will also be associated with this plan",
      "name": "Name",
      "email": "Email",
      "fullName": "Full name",
      "gender": "Gender",
      "male": "Male",
      "female": "Female",
      "add": "Add"
    },
    "membershipCreate": {
      "noMembershipsAvailable": "There are no memberships available for purchase at this time.",
      "availableMemberships": "Available Memberships"
    },
    "membershipIndex": {
      "myMemberships": "My Memberships",
      "memberId": "Your Member ID:",
      "noActiveMemberships": "No active memberships found.",
      "viewAvailableMemberships": "View available memberships",
      "noExpiredMemberships": "You have no expired memberships",
      "viewMemberships": "View Memberships",
      "active": "Active",
      "expired": "Expired"
    },
    "membershipTypeShow": {
      "title": "Complete Membership Selection",
      "backToMemberships": "Back to Memberships",
      "notFoundTitle": "Membership Not Found",
      "notFoundMessage": "This membership doesn't exist or is not available.",
      "viewAvailableMemberships": "View Available Memberships"
    }
  },
  "manager": {
    "membershipSelect": {
      "membershipType": "Membership Type",
      "selectOneOrMore": "Select one or more",
      "typesSelected": "{count} types selected",
      "noMembership": "No membership",
      "allUsers": "All Users"
    },
    "moveMembershipModal": {
      "title": "Move Membership",
      "move": "Move",
      "noMembershipsAvailable": "There are no memberships available to move this user to. Create a new membership to get started.",
      "movePrompt": "Select the membership and plan you would like to move {count} users to.",
      "membershipType": "Membership Type",
      "plan": "Plan",
      "note": "Note:",
      "maintainsDatesNote": "This will maintain the original membership start date, expiration date, and auto-renewal status.",
      "selectMembership": "Select Membership",
      "selectPlan": "Select Plan"
    },
    "createOrEditPlan": {
      "detailsSection": "Details",
      "planNameLabel": "Plan Name *",
      "planNameFeedback": "This field is required and must be 191 characters or less.",
      "planNamePlaceholder": "Enter a name for this plan",
      "planDescriptionLabel": "Plan Description",
      "planDescriptionHint": "Max 250 characters.",
      "planDescriptionFeedback": "This field must be 250 characters or less.",
      "planDescriptionPlaceholder": "Enter a description for this plan",
      "pricingSection": "Pricing",
      "typeLabel": "Type *",
      "typeCostFeedback": "You must provide a cost when the plan type is Fixed Pricing.",
      "priceEditingLocked": "Price editing is currently locked.",
      "contactSupportForPricing": "Contact support to modify pricing for this plan.",
      "userSpecifiesNote": "Note: When 'User specifies' is selected, users will not be able to setup automatic renewals for this plan.",
      "lifetimeNote": "Note: 'Free Lifetime' plans cannot be purchased by users. They can only be assigned by an administrator and will persist until cancellation by an administrator.",
      "billingFrequencyLabel": "Billing Frequency *",
      "billingFrequencyDescription": "How often the user will be billed.",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "boundariesSection": "Boundaries",
      "associatedBoundaryLabel": "Associated Boundary",
      "associatedBoundaryDescription": "Users will only see this plan if their address is within the selected boundary.",
      "controlPlanDisplayLabel": "Control Plan Display",
      "controlPlanDisplayDescription": "Select a plan to hide when the current plan is displayed to the user.",
      "membershipSettingsSection": "Membership Settings",
      "beneficiariesLabel": "Membership Beneficiaries *",
      "beneficiariesDescription": "Controls how many people can benefit from this plan.",
      "accountHolderOnly": "Account holder only",
      "limitedNumberOfPeople": "Limited number of people",
      "unlimited": "Unlimited",
      "maxPeopleLabel": "Maximum number of people",
      "accountHolderHint": "This includes the account holder. If set to 1, the account holder can assign the membership to a family member instead.",
      "businessPlanDescription": "User will be required to enter a business address on checkout when purchasing this plan.",
      "fieldRequired": "This field is required.",
      "businessPlanCheckbox": "Plan is for businesses/corporations",
      "fixedPrice": "Fixed price",
      "userSpecifies": "User specifies",
      "freeLifetime": "Free Lifetime",
      "noBoundaryOption": "--- No Boundary ---",
      "noHiddenPlanOption": "--- No Hidden Plan ---",
      "editPlanTitle": "Edit Plan",
      "createPlanTitle": "Create Plan",
      "planUpdated": "Plan updated!",
      "membershipTypeNotFound": "Membership type not found.",
      "planCreated": "Plan created!",
      "somethingWentWrong": "Something went wrong! Please try again or contact support.",
      "planNotFound": "Plan not found.",
      "membershipTypeProductIdRequired": "Membership type product ID is required for creating a new plan.",
      "failedToLoadData": "Failed to load data. Please refresh the page."
    },
    "membershipSettings": {
      "title": "Membership Settings",
      "automaticCustomMembershipNumbers": "Automatic Custom Membership Numbers",
      "customNumbersDescription": "Define a range of membership numbers that users will be assigned upon successful membership purchase.",
      "membershipNumberPrefixLabel": "Membership Number Prefix *",
      "membershipNumberPrefixDescription": "A prefix that will be prepended to your membership number.",
      "fieldRequired": "This field is required.",
      "startingNumberLabel": "Starting Membership Number *",
      "startingNumberDescription": "Users will be assigned a custom membership number starting at this number.",
      "endingNumberLabel": "Ending Membership Number *",
      "endingNumberDescription": "Users will be assigned a custom membership number ending at this number.",
      "endingNumberRequiredFeedback": "This field is required and must be greater than the starting number.",
      "maintainMembershipNumber": "Maintain auto assigned membership number even after subscription expiration or cancellation.",
      "numbersPreviewStart": "Based on the parameters defined above, users will receive membership numbers starting at",
      "numbersPreviewEnd": "and ending at",
      "autoRenewalSettings": "Auto-Renewal Settings",
      "autoRenewalDescription": "Control the default state of the auto-renewal option presented to users when they sign up for or purchase a membership. Applies to both free and paid memberships.",
      "defaultAutoRenewalToEnabled": "Default auto-renewal to enabled",
      "autoRenewalHelp": "When enabled, the auto-renewal toggle will be pre-selected for both free and paid memberships. Users can still opt out before completing their purchase or signup.",
      "memberDirectory": "Member Directory",
      "memberDirectoryDescription": "Control whether members can view a directory of other members at your organization.",
      "enableMemberDirectory": "Enable member directory",
      "memberDirectoryHelp": "When enabled, members can view a directory of other members at your organization. Only member names are displayed for privacy.",
      "settingsEntity": "Settings",
      "autoRenewalSaveError": "Failed to save auto-renewal settings. Please try again.",
      "memberDirectorySaveError": "Failed to save member directory settings. Please try again."
    },
    "membershipsCreate": {
      "basicInformationTitle": "Basic Information",
      "membershipNameLabel": "Membership Name *",
      "nameRequiredFeedback": "This field is required",
      "namePlaceholder": "Enter a name for this membership",
      "membershipTypeLabel": "Membership Type *",
      "fieldRequiredFeedback": "This field is required.",
      "membershipTypeDescription": "Base memberships are required to be created before add-ons. An example of an Add-on membership could be a 'Tennis Court Membership' which could be tied to booking a tennis court.",
      "selectMembershipTypeOption": "--- Select a Membership Type ---",
      "baseOption": "Base",
      "addonOption": "Add-on",
      "selectBaseMembershipLabel": "Select your desired base membership",
      "baseRequiredFeedback": "This field is required when Add-on is selected.",
      "baseMembershipDescription": "Users will be required to purchase this base membership first or at the same time as this add-on.",
      "selectBaseMembershipOption": "--- Select a Base Membership ---",
      "addonVisibilityLabel": "Add-on Visibility",
      "addonVisibilityDescription": "When enabled, only members who already hold the selected base membership will see this add-on in purchase flows.",
      "hideAddonUnlessBase": "Hide this add-on unless the user has the selected base membership",
      "bundleWithBaseLabel": "Bundle with base membership",
      "bundleWithBaseDescription": "When enabled, only the combined base + add-on appears in member purchase and assign flows. The base membership is not listed on its own. Members who already have the base still add this add-on through that same combined entry.",
      "onlySellAsBundle": "Only sell as a bundle with the base (hide standalone base)",
      "membershipDescriptionLabel": "Membership Description *",
      "max250Description": "Max 250 characters.",
      "descriptionLengthFeedback": "Field is required and must be 250 characters or less.",
      "renewalSettingsTitle": "Renewal Settings",
      "renewalFrequencyLabel": "Renewal Frequency *",
      "specificDateOption": "Specific Date",
      "rollingOption": "Rolling",
      "endDateLabel": "End Date *",
      "endDateDescription": "When the user will be required to renew their membership.",
      "newEndDateTitle": "Important: New End Date Specified",
      "endDateChangedWarning": "The end date is being changed to a new date. Some users may have memberships that expire on the previous end date.",
      "endDateUpdatePrompt": "Do you want to update these existing memberships to expire on the new end date, or keep them set to expire on the previous end date?",
      "updateEndDatesLabel": "Update existing membership end dates:",
      "updateEndDatesFeedback": "A selection must be made when the end date is modified.",
      "daysBeforeExpirationLabel": "Days Before Expiration",
      "daysBeforeExpirationDescription": "The number of days before expiration that users can renew.",
      "numberFeedback": "This field must be a number",
      "userCanSetupAutoRenewal": "User can setup auto-renewal for this membership",
      "autoRenewalDisabledTitle": "Important: Auto-Renewal Disabled",
      "autoRenewalEnabledWarning": "Some users currently have memberships with auto-renewal enabled for this membership type.",
      "cancelAutoRenewalsPrompt": "Do you want to cancel all existing auto-renewals so they expire at the end of their current period?",
      "actionIrreversible": "This action is irreversible.",
      "cancelAutoRenewalsConsequence": "If you choose to cancel existing auto-renewals, affected memberships will not renew and this cannot be undone.",
      "cancelAutoRenewalsLabel": "Cancel existing auto-renewals:",
      "cancelAutoRenewalsFeedback": "A selection must be made when auto-renewal is disabled.",
      "notificationSettingsTitle": "Notification Settings",
      "emailPreExpiration": "Send an email to the user that their membership is about to expire",
      "daysBeforeExpirationEmailLabel": "Days before expiration to send email",
      "requiredWhenCheckedFeedback": "Required when checked. Must be numeric.",
      "emailPostExpiration": "Send an email reminding the user their membership has expired",
      "daysAfterExpirationEmailLabel": "Days after expiration to send email",
      "emailOnExpiration": "Send an email to the user when their membership expires",
      "disableDefaultCardEmail": "Disable the default membership card PDF email for this membership type",
      "additionalSettingsTitle": "Additional Settings",
      "customFormLabel": "Custom Form",
      "customFormDescription": "Select a form to collect additional information during the membership purchase. You can create membership forms in the Forms section.",
      "noFormOption": "--- No Form ---",
      "autoRenewalFormWarning": "Auto-renewal is enabled. When a membership auto-renews, the user will not be prompted to fill out the form again. Form responses cannot be guaranteed for auto-renewed memberships.",
      "waiverDescription": "The user will be forced to agree to the selected waivers before purchasing.",
      "selectWaiversLabel": "Select waivers",
      "excludeFromTax": "Exclude this membership from tax rates",
      "hiddenDescription": "Enabling this setting will prevent the membership from being purchasable by the public. As an administrator, you will still be able to assign this membership to users.",
      "hideFromPublic": "Hide this membership from the public",
      "hideStartingPriceDescription": "When enabled, public and member-facing membership pages will hide the starting price while keeping the membership selectable.",
      "hideStartingAtPrice": "Hide Starting At Price",
      "communalAdminSettingsTitle": "Communal Admin Settings",
      "excludeFromParentTenantFee": "Exclude this membership from parent tenant fee",
      "pageTitle": "Create Membership",
      "endDateBeforeTodayFeedback": "End date cannot be before today.",
      "endDateMaxFeedback": "End date must be within 2 years minus 1 day from today.",
      "updateHeader": "Update Membership",
      "createHeader": "Create Membership",
      "membershipTypeEntity": "Membership type",
      "saveError": "Something went wrong saving.",
      "noCardOption": "No card"
    },
    "membershipsIndex": {
      "membershipTypesTitle": "Membership Types",
      "reorder": "Reorder",
      "resetOrder": "Reset Order",
      "saveOrder": "Save Order",
      "loadItemsError": "Failed to load items for reordering.",
      "orderSaved": "Order saved. This is the order end users will see.",
      "saveOrderError": "Failed to save order.",
      "orderReset": "Manual order reset. End users now see the default order.",
      "resetOrderError": "Failed to reset to natural order."
    },
    "planIndex": {
      "plansTitle": "Plans",
      "membershipTypeFilterLabel": "Membership Type"
    }
  },
  "guest": {
    "membershipIndex": {
      "noMembershipsAvailable": "No memberships available for purchase.",
      "availableMemberships": "Available Memberships"
    }
  }
}
